export function cacheParallelAsyncFn<T, N>(fn: (args: T) => Promise<N>) {
	const cache: Record<string, Promise<N>> = {};

	return (args: T) => {
		const key = JSON.stringify(args);
		if (!cache[key]) {
			const promise = fn(args);
			cache[key] = promise;

			// removing once promise is resolved/rejected so user might retry
			promise.finally(() => {
				delete cache[key];
			});
		}

		return cache[key];
	};
}
